// Services.jsx
import React from 'react';
import './css/Services.css';

const Services = () => {
  return (
    <div className="tractor-minimal">
      {/* Main Title Section */}
      <div className="main-title-section">
        <div className="title-container">
          <div className="title-icon">🚜</div>
          <h1 className="main-title">Machinery Solutions</h1>
          <p className="main-subtitle">Precision. Power. Productivity.</p>
          <p className="main-description">
            Advanced tractor services designed for modern farming efficiency and sustainability.
          </p>
        </div>
      </div>

      {/* Service Cards Grid */}
      <div className="services-container">
        <div className="service-card">
          <div className="card-icon">📋</div>
          <div className="card-content">
            <h3>Smart Leasing</h3>
            <p>Flexible rental options with full maintenance included. No large upfront investment required.</p>
            <div className="card-tags">
              <span className="tag">Monthly Plans</span>
              <span className="tag">No Down Payment</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">🤖</div>
          <div className="card-content">
            <h3>Autonomous Systems</h3>
            <p>GPS-guided driverless tractors for 24/7 operation. Perfect for labor shortage solutions.</p>
            <div className="card-tags">
              <span className="tag">AI Navigation</span>
              <span className="tag">Precision Control</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">🎯</div>
          <div className="card-content">
            <h3>Precision Tech</h3>
            <p>Upgrade existing tractors with smart sensors and automated implement control systems.</p>
            <div className="card-tags">
              <span className="tag">Variable Rate</span>
              <span className="tag">Yield Mapping</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">🔧</div>
          <div className="card-content">
            <h3>Full Support</h3>
            <p>Complete maintenance packages with 24/7 technical support and genuine spare parts.</p>
            <div className="card-tags">
              <span className="tag">24/7 Support</span>
              <span className="tag">On-site Repair</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">📊</div>
          <div className="card-content">
            <h3>Farm Analysis</h3>
            <p>Expert assessment to recommend optimal tractor-implement combinations for your specific needs.</p>
            <div className="card-tags">
              <span className="tag">Custom Solutions</span>
              <span className="tag">Efficiency Audit</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">📈</div>
          <div className="card-content">
            <h3>Performance Tracking</h3>
            <p>Real-time monitoring and analytics to optimize tractor usage and reduce operational costs.</p>
            <div className="card-tags">
              <span className="tag">Fuel Analytics</span>
              <span className="tag">Uptime Reports</span>
            </div>
          </div>
        </div>
      </div>

      {/* =========================
         NEW: MACHINES & DRONES
      ========================== */}
      <div className="main-title-section">
        <div className="title-container">
          <div className="title-icon">🚁</div>
          <h1 className="main-title">Machines & Aerial Services</h1>
          <p className="main-subtitle">Mechanized. Intelligent. Efficient.</p>
          <p className="main-description">
            Advanced agricultural machinery and drone solutions for large-scale and precision farming.
          </p>
        </div>
      </div>

      <div className="services-container">
        <div className="service-card">
          <div className="card-icon">🚜</div>
          <div className="card-content">
            <h3>Heavy Tractors</h3>
            <p>High-power tractors designed for deep ploughing, land preparation, and heavy-duty operations.</p>
            <div className="card-tags">
              <span className="tag">High HP</span>
              <span className="tag">Heavy Implements</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">🌱</div>
          <div className="card-content">
            <h3>Inter Cultivation Tractors</h3>
            <p>Compact and efficient tractors for row crops, weeding, and inter-cultivation tasks.</p>
            <div className="card-tags">
              <span className="tag">Row Crops</span>
              <span className="tag">Fuel Efficient</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">🛩️</div>
          <div className="card-content">
            <h3>Spraying Drones</h3>
            <p>Drone-based chemical and nutrient spraying with precision control and reduced chemical usage.</p>
            <div className="card-tags">
              <span className="tag">Chemical Spraying</span>
              <span className="tag">Precision Coverage</span>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="card-icon">📡</div>
          <div className="card-content">
            <h3>Aerial Modeling & Mapping</h3>
            <p>High-resolution aerial mapping for crop health analysis, land surveys, and yield prediction.</p>
            <div className="card-tags">
              <span className="tag">NDVI Mapping</span>
              <span className="tag">3D Field Models</span>
            </div>
          </div>
        </div>
      </div>

      {/* Feature Highlights */}
      <div className="features-section">
        <div className="feature">
          <div className="feature-number">01</div>
          <div className="feature-content">
            <h4>Cost Reduction</h4>
            <p>Reduce operational costs by up to 40% through optimized tractor utilization and maintenance planning.</p>
          </div>
        </div>

        <div className="feature">
          <div className="feature-number">02</div>
          <div className="feature-content">
            <h4>Labor Solution</h4>
            <p>Address manpower shortages with autonomous systems and on-demand operator services.</p>
          </div>
        </div>

        <div className="feature">
          <div className="feature-number">03</div>
          <div className="feature-content">
            <h4>Yield Increase</h4>
            <p>Improve crop yields through precision farming technology and optimized field operations.</p>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="contact-section">
        <h2 className="contact-title">Ready to Modernize?</h2>
        <p className="contact-text">Get started with a custom tractor or drone solution for your farm.</p>

        <div className="contact-methods">
          <div className="contact-method">
            <div className="method-icon">📞</div>
            <div className="method-details">
              <p>+91-8675221100</p>
              <p>+65-88737903</p>
            </div>
          </div>

          <div className="contact-method">
            <div className="method-icon">✉️</div>
            <div className="method-details">
              <p>k.v.g.krish100@gmail.com</p>
              <p>gokul@greenowledge.onmicrosoft.com</p>
            </div>
          </div>

          <div className="contact-method">
            <div className="method-icon">👤</div>
            <div className="method-details">
              <p>Gokula Krishnan Velmurugan</p>
            </div>
          </div>
        </div>

        <button className="action-button">Schedule Consultation</button>
      </div>
    </div>
  );
};

export default Services;
